import * as React from 'react';

import MediaQuery from 'ha/helpers/MediaQuery';
import withCurrentPageName, {
  PageNameProps,
} from 'ha/helpers/withCurrentPageName';
import {
  LIST_YOUR_PLACE,
  APOLLO_SUPPLY_LANDING,
  SEARCH,
} from 'ha/constants/pageNames';
import NavBarDesktop from './NavBarDesktop';
import NavBarMobile from './NavBarMobile';

const CTA_BLACK_LIST = [LIST_YOUR_PLACE, APOLLO_SUPPLY_LANDING, SEARCH];

const checkIfCTAVisible = (pageName: string, pageCategory?: string) =>
  CTA_BLACK_LIST.includes(pageName) ||
  CTA_BLACK_LIST.includes(pageCategory || '')
    ? false
    : true;

interface Props {
  breadcrumbs?: React.ReactElement<{ withoutFirstSeparator: boolean }> | null;
  isAuthenticated: boolean;
}

export const NavBar: React.SFC<Props & PageNameProps> = ({
  breadcrumbs,
  pageName,
  pageCategory,
  isAuthenticated,
}) => {
  const isCTAVisible = checkIfCTAVisible(pageName, pageCategory);

  return (
    <MediaQuery>
      {({ lg }) =>
        lg ? (
          <NavBarDesktop
            breadcrumbs={breadcrumbs}
            isAuthenticated={isAuthenticated}
            isCTAVisible={isCTAVisible}
          />
        ) : (
          <NavBarMobile
            breadcrumbs={breadcrumbs}
            isAuthenticated={isAuthenticated}
            isCTAVisible={isCTAVisible}
          />
        )
      }
    </MediaQuery>
  );
};

export default withCurrentPageName(NavBar);
